module.exports = __webpack_public_path__ + "img/ing-home-pay.d417f9eb.svg";